import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, BACK_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter, useParams } from 'react-router-dom';
import { fetchDetails, getParsedDate, getDateString, scrollToTop } from './Api';

export default function Presspage(props) {

    // const id = props.id

    const limit = props.limit;

    const styles = {
        backgroundColor: props.color,
    };

    const [press, setpress] = useState([])


    useEffect(() => {
        const fetchData = async () => {

            const url = `${API_URL}/presses/${limit}`;
            const data = await fetchDetails(url);
            if (data) {
                setpress(data);
            }
            scrollToTop();
        };
        fetchData({ limit });
    }, []);



    return (
        <>


            <section className="tg-sectionspace tg-haslayout" id="press" style={styles}>
                <div className="container">
                    <div className="row">

                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                            <div className="tg-sectionhead tg-textalignleft">
                                <div className="tg-sectionheading">
                                    {/* <span>Speakers from around the world</span> */}
                                    <h2>Press & News</h2>
                                </div>

                            </div>
                        </div>

                        <div className="tg-newsarticles">
                            {press.map(pres => (
                                <div key={pres.id} className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                    <div className="tg-articles">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <article className="tg-article press">
                                                    <figure>  <Link target='_blank' to={pres.externalurl}><img src={`${BACK_URL}/${pres.image}`} alt="" style={{ height: "230px" }} /></Link></figure>
                                                    <ul className="tg-postmaradata">
                                                        <li><i className="icon-calendar-full"></i>{getDateString(pres.startdate)}</li>
                                                        <li><i className="icon-newspaper"></i>{pres.author}</li>
                                                    </ul>


                                                    <div className="tg-contentbox" style={styles}>
                                                        <div className="tg-title">
                                                            <h2 className="pressdesc">


                                                                {pres.externalurlstatus == 1 ? <Link target='_blank' to={pres.externalurl}>{pres.title}</Link> : <Link to={`/pagedetail/${pres.id}`}>{pres.title}</Link>}

                                                            </h2>
                                                        </div>


                                                        {/* <a className="tg-btnreadmore" href="javascript">Read more</a> */}
                                                    </div>
                                                </article>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {limit == 3 ? <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                            <div className="tg-sectionhead tg-textaligncentre">
                                <div className="tg-sectionheadingview">
                                    <Link to='/press'><button className="tg-btn">View all</button></Link>
                                </div>
                            </div>
                        </div> : ''}

                    </div>
                </div>
            </section >
        </>
    )
}
